exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-62275c3c] .active-current-row{background-color:var(--tableSelectColor)!important}[data-v-62275c3c] .el-table .cell{white-space:normal!important}[data-v-62275c3c] .is-disconnected{text-decoration:line-through}", ""]);

// exports
